var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.62-169.23q-26.85 0-45.74-18.89Q80-207 80-233.85v-443.07h40v443.07q0 10.77 6.92 17.7 6.93 6.92 17.7 6.92H760v40H144.62Zm120-120q-26.85 0-45.74-18.89Q200-327 200-353.85v-421.53q0-26.85 18.88-45.74Q237.77-840 264.62-840h198.46l80 80h272.3q26.85 0 45.74 18.88Q880-722.23 880-695.38v341.53q0 26.85-18.88 45.73-18.89 18.89-45.74 18.89H264.62Zm0-40h550.76q10.77 0 17.7-6.92 6.92-6.93 6.92-17.7v-341.53q0-10.77-6.92-17.7-6.93-6.92-17.7-6.92H527l-80-80H264.62q-10.77 0-17.7 6.92-6.92 6.93-6.92 17.7v421.53q0 10.77 6.92 17.7 6.93 6.92 17.7 6.92Zm-24.62 0V-800v470.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase);
export default __webpack_public_path__ + "static/media/case.729bb7dfa67b28b3203de304af9999e5.svg";
export { ForwardRef as ReactComponent };